import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';

export interface RestrictionState {
   is_editing: boolean;
}

const RestrictionStore: Module<RestrictionState, StoreState> = {
   namespaced: true,

   state: {
      is_editing: false,
   },

   getters: {},

   mutations: {
      setIsEditing(state, value: boolean) {
         state.is_editing = value;
      },
   },

   actions: {},
};

export default RestrictionStore;
